import { render, staticRenderFns } from "./omt-h5.vue?vue&type=template&id=42fe1775&scoped=true&"
var script = {}
import style0 from "./omt-h5.vue?vue&type=style&index=0&id=42fe1775&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fe1775",
  null
  
)

export default component.exports